{
  "TEAMS_SETTINGS": {
    "NEW_TEAM": "ایجاد تیم جدید",
    "HEADER": "تیم‌ها",
    "LOADING": "Fetching teams",
    "DESCRIPTION": "Teams allow you to organize agents into groups based on their responsibilities. An agent can belong to multiple teams. When working collaboratively, you can assign conversations to specific teams.",
    "LEARN_MORE": "Learn more about teams",
    "COUNT": "{n} team | {n} teams",
    "SEARCH_PLACEHOLDER": "جستجوی تیم...",
    "NO_RESULTS": "No teams found matching your search",
    "LIST": {
      "404": "هیچ تیمی در این حساب ایجاد نشده است.",
      "EDIT_TEAM": "ویرایش تیم",
      "NONE": "هیچکدام"
    },
    "CREATE_FLOW": {
      "CREATE": {
        "TITLE": "ایجاد تیم جدید",
        "DESC": "عنوان و توضیحاتی به تیم جدید خود اضافه کنید."
      },
      "AGENTS": {
        "BUTTON_TEXT": "افزودن ایجنت به تیم",
        "TITLE": "افزودن اپراتور به تیم - {teamName}",
        "DESC": "ایجنت ها را به تیم تازه ایجاد شده خود اضافه کنید. این به شما امکان می دهد به عنوان یک تیم در گفتگوها همکاری کنید ، در رویدادهای جدید در همان مکالمه مطلع شوید."
      },
      "WIZARD_CREATE": {
        "TITLE": "ايجاد كردن",
        "BODY": "یک تیم جدید از ایجنت ها ایجاد نمایید."
      },
      "WIZARD_ADD_AGENTS": {
        "TITLE": "معرفی ایجنت",
        "BODY": "ایجنت ها را به تیم اضافه کنید."
      },
      "WIZARD_FINISH": {
        "TITLE": "پایان",
        "BODY": "دیگه می‌تونی بترکونی"
      }
    },
    "EDIT_FLOW": {
      "CREATE": {
        "TITLE": "ویرایش جزئیات تیم خود",
        "DESC": "ویرایش عنوان و توضیحات تیم خود.",
        "BUTTON_TEXT": "به‌روزرسانی تیم"
      },
      "AGENTS": {
        "BUTTON_TEXT": "ایجنت ها را در تیم به روز کنید",
        "TITLE": "افزودن اپراتور به تیم - {teamName}",
        "DESC": "ایجنت ها را به تیم تازه ایجاد شده خود اضافه کنید. وقتی مکالمه ای به این تیم اختصاص داده شود ، به همه ایجنت ها اضافه شده اطلاع داده می شود."
      },
      "EDIT_WIZARD_DETAILS": {
        "TITLE": "جزئیات تیم",
        "ROUTE": "settings_teams_edit",
        "BODY": "نام ، توضیحات و سایر جزئیات را تغییر دهید."
      },
      "EDIT_WIZARD_AGENTS": {
        "TITLE": "تغییر ایجنت ها",
        "ROUTE": "settings_teams_edit_members",
        "BODY": "ایجنت ها تیم خود را ویرایش کنید."
      },
      "EDIT_WIZARD_FINISH": {
        "TITLE": "پایان",
        "ROUTE": "settings_teams_edit_finish",
        "BODY": "دیگه می‌تونی بترکونی"
      }
    },
    "TEAM_FORM": {
      "ERROR_MESSAGE": "جزئیات تیم ذخیره نشد. دوباره امتحان کنید."
    },
    "AGENTS": {
      "AGENT": "ایجنت",
      "EMAIL": "ایمیل",
      "BUTTON_TEXT": "اضافه کردن اپراتور",
      "ADD_AGENTS": "افزودن ایجنت ها به تیم شما...",
      "SELECT": "انتخاب کنید",
      "SELECT_ALL": "انتخاب تمام ایجنت ها",
      "SELECTED_COUNT": "{selected} تا از {total} ایجنت انتخاب شد."
    },
    "ADD": {
      "TITLE": "افزودن اپراتور به تیم - {teamName}",
      "DESC": "ایجنت ها را به تیم تازه ایجاد شده خود اضافه کنید. این به شما امکان می دهد به عنوان یک تیم در گفتگوها همکاری کنید ، در رویدادهای جدید در همان مکالمه مطلع شوید.",
      "SELECT": "انتخاب کنید",
      "SELECT_ALL": "انتخاب تمام ایجنت ها",
      "SELECTED_COUNT": "{selected} تا از {total} ایجنت انتخاب شد.",
      "BUTTON_TEXT": "اضافه کردن اپراتور",
      "AGENT_VALIDATION_ERROR": "حداقل یک اپراتور را انتخاب کنید."
    },
    "FINISH": {
      "TITLE": "تیم شما آماده است!",
      "MESSAGE": "اکنون می توانید به عنوان یک تیم در گفتگوها همکاری کنید ",
      "BUTTON_TEXT": "پایان"
    },
    "DELETE": {
      "BUTTON_TEXT": "حذف",
      "API": {
        "SUCCESS_MESSAGE": "تیم با موفقیت حذف شد.",
        "ERROR_MESSAGE": "تیم حذف نشد. دوباره امتحان کنید."
      },
      "CONFIRM": {
        "TITLE": "Are you sure you want to delete the team?",
        "PLACE_HOLDER": "برای تایید لطفا {teamName} را تایپ کنید",
        "MESSAGE": "با حذف تیم ، وظایف تیم از مکالمات اختصاص داده شده به این تیم حذف می شود.",
        "YES": "حذف ",
        "NO": "انصراف"
      }
    },
    "SETTINGS": "تنظیمات",
    "FORM": {
      "UPDATE": "به‌روزرسانی تیم",
      "CREATE": "ایجاد تیم",
      "NAME": {
        "LABEL": "نام تیم",
        "PLACEHOLDER": "مثال: فروش ، پشتیبانی مشتری"
      },
      "DESCRIPTION": {
        "LABEL": "توضیحات تیم",
        "PLACEHOLDER": "توضیح مختصری در مورد این تیم."
      },
      "AUTO_ASSIGN": {
        "LABEL": "مجاز به تعیین خودکار برای این تیم."
      },
      "SUBMIT_CREATE": "ایجاد تیم"
    }
  }
}
